export enum ConfirmationType {
    PUBLISH_WEBSITE = 'publish_website',
}
